import { object as objectType, string as stringType, boolean as booleanType, ZodIssueCode } from '../../../../_externals/.pnpm/zod@3.23.8/node_modules/zod/lib/index.js';

var requiredString = function (fieldName, errors) {
    return stringType({
        required_error: (errors === null || errors === void 0 ? void 0 : errors[fieldName]) || "".concat(fieldName, " is required"),
    })
        .min(1, { message: (errors === null || errors === void 0 ? void 0 : errors[fieldName]) || "".concat(fieldName, " is required") });
};
var generateSchema = function (type, errors) {
    return objectType({
        firstName: requiredString("firstName", errors),
        lastName: requiredString("lastName", errors),
        country: requiredString("country", errors),
        lineOne: requiredString("lineOne", errors),
        lineTwo: stringType().optional(),
        city: requiredString("city", errors),
        postalcode: requiredString("postalcode", errors),
        province: stringType().optional(),
        email: type === "checkout"
            ? requiredString("email", errors).email({
                message: (errors === null || errors === void 0 ? void 0 : errors.email) || "Invalid email address",
            })
            : stringType().optional(),
        dialingCode: stringType().optional(),
        phoneNumber: stringType().optional(),
        consent: booleanType().optional(),
    })
        .superRefine(function (data, ctx) {
        var _a;
        if (type === "checkout" &&
            data.country !== "GB" &&
            !((_a = data.phoneNumber) === null || _a === void 0 ? void 0 : _a.replace(/\+/g, ""))) {
            ctx.addIssue({
                code: ZodIssueCode.custom,
                message: (errors === null || errors === void 0 ? void 0 : errors.phoneNumber) || "Phone number is required",
                path: ["phoneNumber"],
            });
        }
        // Province validation for specific countries
        if (["US", "CA", "IE"].includes(data.country) && !data.province) {
            ctx.addIssue({
                code: ZodIssueCode.custom,
                message: (errors === null || errors === void 0 ? void 0 : errors.province) || "Province is required for US, CA, or IE",
                path: ["province"],
            });
        }
    });
};
generateSchema("checkout");

export { generateSchema };
//# sourceMappingURL=AddressForm.schema.js.map
